let form = document.querySelector('.search-modal-form');

form.addEventListener('submit', function(e) {
    e.preventDefault();
    let text = form.querySelector('.form-input input');
    if (text.value){
        location = `https://www.correiobraziliense.com.br/busca/${text.value}`
    }
})